import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import arrow from "../assets/arrow.svg";
import { requestWithToken } from "../utils/apis";
import moment from "moment";
import { formatPhoneNumber, helpPagesData } from "../utils/helper";
import { Spinner } from "react-bootstrap";
import Help from "../components/Help";
import CommonModal from "../components/CommonModal";
import eye from "../assets/eye.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Paginate from "../components/pagination";
import DeployTrigger from "../components/DeployTrigger";

const ContactForms = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [exportLoader, setExportLoader] = useState(false);
  const [formData, setFormData] = useState({
    loading: false,
    data: [],
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
  });
  const fetchContactForms = async () => {
    setFormData({ ...formData, loading: true });
    try {
      const result = await requestWithToken(
        "GET",
        `/api/contact-form/list?page=${pagination.page}&limit=${pagination.limit}`
      );
      if (result?.status === 200) {
        setPagination((prev) => ({
          ...prev,
          total: Math.ceil(result.data.data.total / prev.limit) || 0,
        }));
        setFormData({ data: result?.data?.data?.list || [], loading: false });
      }
    } catch (error) {
      setFormData({ data: [], loading: false });
    }
  };
  useEffect(() => {
    fetchContactForms();
  }, [params]);

  const handleContactFormCSVExport = async () => {
    setExportLoader(true);
    try {
      const result = await requestWithToken("GET", `/api/contact-form/export`);

      if (result?.status === 200 && result?.data?.data) {
        const fileUrl = result.data.data;

        // Generate smart filename (timestamped if none available)
        const fileName = `contact-form-${new Date()
          .toISOString()
          .slice(0, 19)
          .replace(/[:T]/g, "-")}.csv`;

        // Create an invisible <a> element to trigger download
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName); // suggest filename
        // link.setAttribute("target", "_blank");   // keep app safe
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error("CSV export failed:", error);
    } finally {
      setExportLoader(false);
    }
  };

  const handlePageChange = (page) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("page", page);
    newParams.set("limit", pagination.limit);

    navigate(`?${newParams.toString()}`, { replace: true });

    setPagination((prev) => ({ ...prev, page: page }));
  };

  const handlePageSizeChange = (limit) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("page", 1);
    newParams.set("limit", limit);

    navigate(`?${newParams.toString()}`, { replace: true });

    setPagination((prev) => ({ ...prev, limit: limit, page: 1 }));
  };

  const { loading, data = [] } = formData;
  return (
    <>
      <PageHeader pageTitle="All Forms">

          <Help
            title={helpPagesData.pages.title}
            message={helpPagesData.pages.message}
            items={helpPagesData.pages.items}
          />
          <button className="btn-black" onClick={handleContactFormCSVExport}>
            {exportLoader ? <Spinner size="sm" /> : "Export CSV"}
          </button>
    
      </PageHeader>
      <div className="page-container">
        <div className="theme-card p-4">
          <div className="card-title pb-3">All Forms</div>
          <div className="table-responsive">
            <table className="pages-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Date Submitted</th>
                  <th style={{ textAlign: "center" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      <Spinner size="md" />
                    </td>
                  </tr>
                ) : data?.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No submissions found.
                    </td>
                  </tr>
                ) : (
                  data.map((form, index) => (
                    <tr key={index}>
                      <td>{form.name || "-"}</td>
                      <td>{form.email || "-"}</td>
                      <td>
                        {form?.contact
                          ? formatPhoneNumber(form.contact, form.country_code)
                          : "-"}
                      </td>
                      <td>
                        {moment(form.createdAt).format(
                          "DD/MM/YYYY"
                        )}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        <button
                          onClick={() => {
                            setSelectedRow(form);
                            setShowModal(true);
                          }}
                        >
                          <img src={eye} alt="view" />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            <div className="pt-3">
              {Boolean(pagination?.total) && (
                <Paginate
                  currentPage={pagination?.page}
                  totalPages={pagination?.total}
                  onPageChange={handlePageChange}
                  pageSize={pagination.limit}
                  onPageSizeChange={handlePageSizeChange}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <CommonModal show={showModal} onClose={() => setShowModal(false)}>
        <div className="modal-card-body p-3">
          <div className="modal-card-content">
            <div className="card-title mb-3">Complete Details</div>
            <div className="contact-name">Name</div>
            <div className="contact-details">{selectedRow?.name || "-"}</div>
            <div className="contact-name">Email</div>
            <div className="contact-details">{selectedRow?.email || "-"}</div>
            <div className="contact-name">Phone</div>
            <div className="contact-details">
              {selectedRow?.contact
                ? formatPhoneNumber(
                    selectedRow?.contact,
                    selectedRow?.country_code
                  )
                : "-"}
            </div>
            <div className="contact-name">Message</div>
            <div className="contact-details">{selectedRow?.query || "-"}</div>
          </div>
          <div className="card-footer-box">
            <button
              className="btn-black ms-auto"
              onClick={() => setShowModal(false)}
            >
              Okay
            </button>
          </div>
        </div>
      </CommonModal>
    </>
  );
};

export default ContactForms;
